// extracted by mini-css-extract-plugin
export default {"wrapper":"WatchwordsTable_wrapper__ewVcm","header":"WatchwordsTable_header__WZzIv","description":"WatchwordsTable_description__7sJ+e","table":"WatchwordsTable_table__310Tc"};